import React from 'react';
import { useTranslation } from 'react-i18next';
import './MaintenancePage.css';

const MaintenancePage = () => {
  const { t } = useTranslation();

  return (
    <div className="maintenance-page">
      <div className="maintenance-content">
        <img
          src={`${process.env.PUBLIC_URL || ''}/images/logo.webp`}
          alt="Pussikuskit"
          className="maintenance-logo"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
        <h1 className="maintenance-title">{t('maintenance.title')}</h1>
      </div>
    </div>
  );
};

export default MaintenancePage;
